// برگه‌های سوخت / روغن خودرو (isFuel: 1 سوخت، 0 روغن)
import React, { useState, useEffect } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { usePagedList, CountBadge } from '../../components/paging';
import { ExcelButton } from '../../components/excel';
import WarningDialog from '../../components/WarningDialog';
import { openReport } from '../../components/report';
import { useFormButtons } from '../../utils/vbPerms';
import {
  API, qs, toFa, Grid, Field, TextIn, DateIn, Lookup, SuggestIn, Modal, DeleteDialog, MsgDialog, excelCols, smallBtn,
} from './carsShared';

const BUTTONS = ['BTNNEW', 'BTNEDIT', 'BTNDELETE', 'BTNOK', 'BTNCANCEL', 'BTNNEWREQUEST', 'BTNCARFUEL', 'BTNFUELREQUEST',
  'BTNFUELCONFIRM', 'BTNFUELHAVALEH'];
const SUB_FUELS = ['بنزین', 'گاز'];
const num = v => Number(String(v ?? '').replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)).replace(/,/g, '')) || 0;

const blank = (keep = {}) => ({
  event_date: '', kilometer: '', amount: '', fee: '', sum_pay: '', sub_fuel_id: 0, paid_before: false,
  letter_no: '', letter_date: '', factor_no: '', factor_date: '', remark: '',
  request_no: '', request_date: '', confirm_no: '', confirm_date: '',
  asker: { id: 0, title: '' }, department: { id: 0, title: '' }, receiver: { id: 0, title: '' }, ...keep,
});

function rowToForm(r) {
  return blank({
    event_date: r['تاریخ'] || '', kilometer: r['کیلومتر'] ?? '', amount: r['مقدار'] ?? '', fee: r['فی'] ?? '',
    sum_pay: r['مبلغ'] ?? '', sub_fuel_id: r.SubFuelId || 0, paid_before: !!r.PaidBefore,
    letter_no: r['شماره نامه معرفی'] || '', letter_date: r['تاریخ نامه معرفی'] || '',
    factor_no: r['شماره فاکتور'] || '', factor_date: r['تاریخ فاکتور'] || '', remark: r['توضیح'] || '',
    request_no: r.RequestNo ?? '', request_date: r.RequestDate || '', confirm_no: r['شماره تایید'] ?? '',
    confirm_date: r['تاریخ تایید'] || '',
    asker: { id: r.AskerId || 0, title: r['درخواست کننده'] || '' },
    department: { id: r.DepartmentId || 0, title: r['واحد اجرایی'] || '' },
    receiver: { id: r.AmountReceiverId || 0, title: r['فروشنده/گیرنده وجه'] || '' },
    hz_no: r['سندهزینه'], hz_date: r['تاریخ سندهزینه'],
  });
}

function FuelForm({ form, F, showSub, onFeeLeave }) {
  return (
    <>
      <div style={ui.row}>
        <Field label="تاریخ"><DateIn value={form.event_date} onChange={v => F('event_date', v)} /></Field>
        <Field label="کیلومتر"><TextIn num value={form.kilometer} onChange={v => F('kilometer', v)} /></Field>
        <Field label="مقدار"><TextIn num value={form.amount} onChange={v => F('amount', v)} onBlur={onFeeLeave} /></Field>
        <Field label="فی"><TextIn num value={form.fee} onChange={v => F('fee', v)} onBlur={onFeeLeave} /></Field>
        <Field label="جمع مبلغ"><TextIn num value={form.sum_pay} onChange={v => F('sum_pay', v)} onBlur={onFeeLeave} /></Field>
        {showSub && (
          <Field label="سوخت">
            <select value={form.sub_fuel_id} onChange={e => F('sub_fuel_id', Number(e.target.value))} style={ui.input}>
              {SUB_FUELS.map((f, i) => <option key={i} value={i}>{f}</option>)}
            </select>
          </Field>
        )}
      </div>
      <div style={ui.row}>
        <Field label="درخواست: شماره"><TextIn num value={form.request_no} onChange={v => F('request_no', v)} /></Field>
        <Field label="تاریخ"><DateIn value={form.request_date} onChange={v => F('request_date', v)} /></Field>
        <Field label="تایید: شماره"><TextIn num value={form.confirm_no} onChange={v => F('confirm_no', v)} /></Field>
        <Field label="تاریخ"><DateIn value={form.confirm_date} onChange={v => F('confirm_date', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="درخواست کننده"><Lookup path="/fuel/lookup/people/" value={form.asker} onChange={v => F('asker', v)} /></Field>
        <Field label="واحد اجرایی"><Lookup path="/fuel/lookup/department/" value={form.department} onChange={v => F('department', v)} /></Field>
        <Field label="جایگاه سوخت/گیرنده وجه"><Lookup path="/fuel/lookup/receiver/" value={form.receiver} onChange={v => F('receiver', v)} /></Field>
      </div>
      <div style={ui.row}>
        <label style={{ fontSize: '12px', alignSelf: 'center' }}>
          <input type="checkbox" checked={form.paid_before} onChange={e => F('paid_before', e.target.checked)} /> بدون پرداخت وجه
        </label>
        {form.paid_before && <>
          <Field label="نامه معرفی: شماره"><TextIn num value={form.letter_no} disabled onChange={() => {}} /></Field>
          <Field label="تاریخ"><TextIn num value={form.letter_date} disabled onChange={() => {}} /></Field>
          <Field label="فاکتور"><TextIn num value={form.factor_no} onChange={v => F('factor_no', v)} /></Field>
          <Field label="تاریخ"><DateIn value={form.factor_date} onChange={v => F('factor_date', v)} /></Field>
        </>}
      </div>
      <div style={ui.row}>
        <Field label="توضیح"><SuggestIn path="/fuel/remarks/" value={form.remark} onChange={v => F('remark', v)} /></Field>
      </div>
    </>
  );
}

export default function CarsFuel({ user, onBack, carId, isFuel = 1, carTitle = '', year }) {
  const fb = useFormButtons('FRMCARSFUEL', BUTTONS);
  const gds = isFuel ? 'سوخت' : 'روغن';
  const [cols, setCols] = useState([]);
  const [car, setCar] = useState({});
  const [sel, setSel] = useState(null);
  const [req, setReq] = useState(null);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(blank());
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');
  const [newReq, setNewReq] = useState(false);
  const [range, setRange] = useState({ from: '', to: '', all: false });
  const [askConfirm, setAskConfirm] = useState(false);
  const [saving, setSaving] = useState(false);

  const L = usePagedList((page) => API(`/fuel/?${qs({ page, car_id: carId, is_fuel: isFuel })}`)
    .then(j => { if (j.ok && page === 1) { setCols(j.columns || []); setCar(j.car || {}); } return j; }));
  const reload = () => L.reload({});
  useEffect(() => { if (fb.open) reload(); }, [fb.open]);

  useEffect(() => {
    setReq(null);
    if (!sel) return;
    const d = sel['تاریخ'] || '';
    setRange(r => (r.from.length === 10 ? r : {
      ...r, from: d.slice(0, 8) + '01', to: d.slice(0, 8) + (Number(d.slice(5, 7)) <= 6 ? '31' : '30'),
    }));
    API(`/fuel/request-grid/?${qs({ is_fuel: isFuel, request_no: sel.RequestNo, request_date: sel.RequestDate })}`)
      .then(j => { if (j.ok && j.data.length) setReq(j); });
  }, [sel, isFuel]);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const onFeeLeave = () => setForm(f => (num(f.fee) !== 0 ? { ...f, sum_pay: Math.round(num(f.fee) * parseFloat(String(f.amount || 0)) || 0) } : f));

  const openNew = async () => {
    const j = await API(`/fuel/prepare/?${qs({ car_id: carId, is_fuel: isFuel, mode: 'new', year })}`);
    if (!j.ok) { setMsg(j.msg); return; }
    setForm(f => blank({
      asker: f.asker.id ? f.asker : { id: j.asker_id, title: j.asker },
      department: f.department.id ? f.department : { id: j.department_id, title: j.department },
      receiver: f.receiver.id ? f.receiver : { id: j.receiver_id, title: j.receiver },
      request_no: j.request_no, request_date: j.request_date, confirm_no: j.confirm_no, confirm_date: j.confirm_date,
    }));
    if (j.msgs && j.msgs.length) setMsg(j.msgs.join('\n'));
    setErr(''); setNewReq(true); setModal('new');
  };
  const openEdit = async () => {
    const j = await API(`/fuel/prepare/?${qs({ car_id: carId, id: sel.CarFuelId, is_fuel: isFuel, mode: 'edit' })}`);
    if (!j.ok) { setMsg(j.msg); return; }
    setForm(rowToForm(sel)); setErr(''); setNewReq(false); setModal('edit');
  };
  const newRequest = async () => {
    const j = await API(`/fuel/new-request/?${qs({ request_date: form.request_date, confirm_date: form.confirm_date, year })}`);
    if (j.ok) {
      setForm(f => ({ ...f, request_no: j.request_no, request_date: j.request_date, confirm_no: j.confirm_no, confirm_date: j.confirm_date }));
      if (j.msgs && j.msgs.length) setMsg(j.msgs.join('\n'));
    }
  };

  const save = async () => {
    setSaving(true); setErr('');
    const body = JSON.stringify({
      ...form, is_fuel: isFuel, car_id: carId, asker_id: form.asker.id, department_id: form.department.id, receiver_id: form.receiver.id,
    });
    const y = year ? `?year=${year}` : '';
    const j = modal === 'new'
      ? await API(`/fuel/create/${y}`, { method: 'POST', body })
      : await API(`/fuel/${sel.CarFuelId}/update/${y}`, { method: 'PUT', body });
    setSaving(false);
    if (!j.ok) { setErr(j.msg); if (j.new_request) setNewReq(true); return; }
    if (j.info) setMsg(j.info);
    reload();
    if (modal === 'new') {
      setForm(f => ({
        ...f, event_date: '', kilometer: '', sum_pay: '', paid_before: false, letter_no: '', letter_date: '',
        factor_no: '', factor_date: '', remark: '', request_no: j.request_no, request_date: j.request_date,
        confirm_no: j.confirm_no, confirm_date: j.confirm_date,
      }));
    } else setModal(null);
  };

  const doDelete = async () => {
    setModal(null);
    const j = await API(`/fuel/${sel.CarFuelId}/delete/`, { method: 'DELETE' });
    if (!j.ok) setMsg(j.msg); else { setSel(null); reload(); }
  };

  const report = async (key, params) => { try { await openReport(key, params); } catch (e) { setMsg(e.message); } };
  const has = !!sel;
  const havaleh = sel && sel.PaidBefore && !Number(sel['شماره فاکتور'] || 0) && fb.can('BTNNEW') && fb.can('BTNFUELHAVALEH');

  const toolbar = fb.open ? (
    <>
      <div style={ui.toolBtns}>
        {fb.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
        {fb.can('BTNEDIT') && <button disabled={!has} onClick={openEdit} style={{ ...ui.btnEdit, opacity: has ? 1 : 0.4 }}>✎ ویرایش</button>}
        {fb.can('BTNDELETE') && <button disabled={!has} onClick={() => setModal('delete')} style={{ ...ui.btnDel, opacity: has ? 1 : 0.4 }}>✕ حذف</button>}
        {havaleh && <button onClick={() => report('tadarokat.car_fuel_havaleh', { id: sel.CarFuelId })} style={smallBtn('#00695c')}>{isFuel ? 'حواله سوخت' : 'حواله روغن'}</button>}
      </div>
      {fb.can('BTNCARFUEL') && <>
        <Field label="تاریخ قبض: از" width="130px"><DateIn value={range.from} onChange={v => setRange(r => ({ ...r, from: v }))} /></Field>
        <Field label="تا" width="130px"><DateIn value={range.to} onChange={v => setRange(r => ({ ...r, to: v }))} /></Field>
        <label style={{ fontSize: '12px', alignSelf: 'center' }}><input type="checkbox" checked={range.all} onChange={e => setRange(r => ({ ...r, all: e.target.checked }))} /> همه ی درخواستها</label>
        <button onClick={() => report('tadarokat.car_fuel_statement', { car_id: carId, is_fuel: isFuel, from: range.from, to: range.to, all: range.all ? 1 : 0, request_no: sel?.RequestNo || 0, request_date: sel?.RequestDate })}
          style={smallBtn()}>{isFuel ? 'صورت سوخت مصرفی' : 'صورت روغن مصرفی'}</button>
      </>}
      {fb.can('BTNFUELREQUEST') && <button disabled={!has} onClick={() => report('tadarokat.car_fuel_request', { is_fuel: isFuel, request_no: sel.RequestNo, request_date: sel.RequestDate })} style={{ ...smallBtn(), opacity: has ? 1 : 0.4 }}>برگه درخواست</button>}
      {fb.can('BTNFUELCONFIRM') && <button disabled={!has} onClick={() => setAskConfirm(true)} style={{ ...smallBtn(), opacity: has ? 1 : 0.4 }}>تاییدیه</button>}
      <CountBadge shown={L.data.length} total={L.pager.total} loading={L.loading} unit="برگه" />
      <ExcelButton title={`${gds} خودروها`} subtitle={carTitle} columns={excelCols(cols, L.data)} rows={L.data} />
    </>
  ) : null;

  const showSub = isFuel === 1 && car.fuel_id === 2;

  return (
    <>
      <ListPage user={user} onBack={onBack} title={`ثبت برگه های ${gds} ${carTitle || car.title || ''}`} subtitle="تدارکات — سامانه ارجان"
        toolbar={toolbar} error={L.error} pager={L.pager} onMore={L.more} loading={L.loading} unit="برگه">
        <div style={ui.splitWrap}>
          <div style={ui.topPane}>
            <Grid columns={cols} rows={L.data} rowKey="CarFuelId" selectedKey={sel?.CarFuelId} onSelect={setSel} moneyCols={['فی', 'مبلغ']} />
          </div>
          {req && (
            <div style={ui.bottomPane}>
              <div style={{ padding: '6px 10px', fontWeight: 700, fontSize: '12px', color: '#1a2f50' }}>
                ریز درخواست شماره {toFa(sel?.RequestNo)} تاریخ {toFa(sel?.RequestDate)}
              </div>
              <Grid columns={req.columns} rows={req.data} rowKey="CarFuelId" moneyCols={['فی', 'مبلغ']} />
            </div>
          )}
        </div>
      </ListPage>

      {(modal === 'new' || modal === 'edit') && (
        <Modal title={modal === 'new' ? `＋ برگه ${gds} جدید` : `✎ ویرایش برگه ${gds}`} onClose={() => setModal(null)} width="900px"
          footer={<>
            {newReq && fb.can('BTNOK') && <button onClick={newRequest} style={smallBtn('#6a1b9a')}>شماره درخواست جدید</button>}
            <button onClick={() => setModal(null)} style={ui.btnCancel}>لغو</button>
            {fb.can('BTNOK') && fb.can(modal === 'new' ? 'BTNNEW' : 'BTNEDIT') &&
              <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : 'ثبت'}</button>}
          </>}>
          {err && <div style={{ ...ui.errBox, whiteSpace: 'pre-line' }}>⚠️ {err}</div>}
          <FuelForm form={form} F={F} showSub={showSub} onFeeLeave={onFeeLeave} />
          {modal === 'edit' && (form.hz_no ? <div style={{ fontSize: '12px', color: '#555' }}>سند هزینه {toFa(form.hz_no)} تاریخ {toFa(form.hz_date)}</div> : null)}
        </Modal>
      )}
      {modal === 'delete' && <DeleteDialog onConfirm={doDelete} onCancel={() => setModal(null)} />}
      {askConfirm && (
        <WarningDialog title="انتخاب کنید" lines={[]} confirmLabel="تاییدیه" cancelLabel="صورتجلسه مصرف"
          onConfirm={() => { setAskConfirm(false); report('tadarokat.car_fuel_confirm', { is_fuel: isFuel, confirm_no: sel['شماره تایید'], confirm_date: sel['تاریخ تایید'], request_date: sel.RequestDate, is_confirm: 1 }); }}
          onCancel={() => { setAskConfirm(false); report('tadarokat.car_fuel_confirm', { is_fuel: isFuel, confirm_no: sel['شماره تایید'], confirm_date: sel['تاریخ تایید'], request_date: sel.RequestDate, is_confirm: 0 }); }} />
      )}
      {msg && <MsgDialog text={msg} onClose={() => setMsg('')} />}
    </>
  );
}
